<router-outlet *ngIf="translationLoaded"></router-outlet>